import type { CartInfo } from '@repo/api/web/models'
import { defineStore } from 'pinia'

export const useCartStore = defineStore('cart', () => {
  const cart = ref<CartInfo>()

  function setCart(value: CartInfo) {
    cart.value = value
  }

  const totalLength = computed(
    () =>
      cart.value?.items?.reduce((acc, item) => acc + (item.amount || 1), 0)
      || 0,
  )

  function reset() {
    cart.value = undefined
  }

  return {
    cart,
    totalLength,

    setCart,
    reset,
  }
})
